/**
 * NAO checkout — persistencia del borrador del formulario en localStorage.
 * Recibe el contexto compartido (`ctx`) que arma el entry (nao-checkout.js).
 */

import { CACHE_EXPIRY, SENSITIVE_KEYS, MACHINE_KEYS, CITY_ALIASES } from '@theme/nao-checkout-data';

export function saveToLocalStorage(ctx) {

    const { elements, lsKey } = ctx;

    if (!elements.form) return;

    const formData = new FormData(elements.form);

    const data = {
        _savedAt: Date.now()
    };

    formData.forEach((value, key) => {

        if (
            key !== 'honeypot' &&
            !SENSITIVE_KEYS.includes(key) &&
            !MACHINE_KEYS.includes(key)
        ) {
            data[key] = value;
        }
    });

    localStorage.setItem(
        lsKey,
        JSON.stringify(data)
    );
}

export function loadSavedData(ctx) {

    const { elements, lsKey } = ctx;

    try {

        const savedRaw =
            localStorage.getItem(lsKey);

        if (!savedRaw) return;

        const savedData =
            JSON.parse(savedRaw);

        const isExpired =
            Date.now() - savedData._savedAt >
            CACHE_EXPIRY;

        if (isExpired) {
            localStorage.removeItem(lsKey);
            return;
        }

        Object.keys(savedData).forEach(key => {

            // Los borradores guardados antes de este cambio pueden traer
            // campos de máquina; se ignoran al leer, no solo al escribir.
            if (MACHINE_KEYS.includes(key)) return;

            const input =
                elements.form.querySelector(
                    `[name="${key}"]`
                );

            if (!input) return;

            input.value = savedData[key];

            if (key === 'province') {

                ctx.populateCities(savedData[key]);

                setTimeout(() => {

                    const cityInput =
                        elements.form.querySelector(
                            '[name="city"]'
                        );

                    if (cityInput) {

                        const saved = savedData.city || '';

                        // Un borrador anterior a un renombrado de ciudad trae
                        // un valor que ya no existe entre las opciones: sin
                        // traducirlo, el select se queda en blanco.
                        cityInput.value =
                            CITY_ALIASES[saved] || saved;
                    }

                }, 50);
            }
        });

    } catch (error) {

        localStorage.removeItem(lsKey);
    }
}
